import { Box, Button, Alert, Typography } from "@mui/material";

type Props = {
  handleEdit: () => void;
};

export default function CampaignTextNoText({ handleEdit }: Props) {
  return (
    <Box sx={styles.noTextContainer}>
      <Box>
        <p>No text set.</p>
        <Alert severity="info" variant="filled" sx={{ mt: 1 }}>
          <Box sx={{ display: 'flex' }}>
            <Typography sx={{ fontWeight: 'bold' }}>STEP 2:</Typography>
            <Typography sx={{ ml: 0.5 }}>Create your campaign message</Typography>
          </Box>
        </Alert>
      </Box>
      <Box sx={styles.createMessageButtonContainer}>
        <Button
          variant="outlined"
          color="primary"
          onClick={handleEdit}
          sx={styles.createMessageButton}
        >
          Create Message
        </Button>
      </Box>
    </Box>
  );
}

const styles = {
  noTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    paddingTop: '4px'
  },
  createMessageButtonContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: '28px'
  },
  createMessageButton: {
    px: 4,
    py: 1,
    fontSize: '1rem',
    minWidth: '180px'
  }
};
